import * as atoms from '@/config/globalStateControl';

import { ActionIcon, Group, createStyles } from '@mantine/core';

import ConfirmationPopup from '@/components/ConfirmationPopup';
import DMText from '@/components/DMText';
import { IconBookmark } from '@tabler/icons-react';
import themeVariables from '@/styles/themeVariables';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

const useBookmarkButtonStyles = createStyles(() => ({
  icon: {
    verticalAlign: 'middle',
  },
}));

const BookmarkButton = ({
  actionSize = 36,
  size = 27,
  active = false,
  label = '',
  className = '',
  onClick,
  color = 'red',
}: {
  actionSize?: number;
  size?: number;
  active?: boolean;
  label?: string;
  className?: string;
  color?: 'white' | 'red';
  onClick: any;
}) => {
  const { classes } = useBookmarkButtonStyles();

  const [filled, setFilled] = useState(active || false);

  const isSignedIn = useAtomValue(atoms.isSignedIn);

  return (
    <Group
      variant={'transparent'}
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!isSignedIn) {
          ConfirmationPopup.login();
          return;
        }

        onClick();
        setFilled((prev) => !prev);
        e.currentTarget.setAttribute('data-active', 'true');
      }}
    >
      <ActionIcon size={actionSize} variant={'transparent'}>
        <IconBookmark
          size={size}
          stroke={1.75}
          fill={
            filled
              ? themeVariables.colors[color == 'red' ? 'red300' : 'white']
              : themeVariables.colors.transparent
          }
          color={themeVariables.colors[color == 'red' ? 'red300' : 'white']}
          className={classes.icon}
        />
      </ActionIcon>
      {label && (
        <DMText
          dColor={themeVariables.darkMode.normal}
          sx={(theme) => ({
            [theme.fn.smallerThan('sm')]: {
              display: 'none',
            },
          })}
        >
          {label}
        </DMText>
      )}
    </Group>
  );
};

export default BookmarkButton;
